import { Link } from '@atlassian/amkt-common';
import { appDetailsLink } from '@atlassian/mpac-utils';
import React from 'react';
export const makeAppDetailsLink = eligibleApps => eligibleApps.length > 0 && eligibleApps.map(app => /*#__PURE__*/React.createElement(Link, {
  key: app.label,
  href: appDetailsLink().expand({
    appKey: app.value
  }),
  target: "_blank"
}, app.label)).reduce((prev, curr) => [prev, ', ', curr]);